module.exports = __webpack_public_path__ + "static/assets/2cdba69cc9226b8e1f0298d7ef8fa6e2.svg";